export enum DateFormat {
    default = 'YYYY-MM-DD', // ISO 8601
    'en-GB' = 'DD/MM/YYYY',
    'en-US' = 'MM/DD/YYYY',
    'de-DE' = 'DD.MM.YYYY',
    'fr-FR' = 'DD/MM/YYYY',
    'sv-SE' = 'YYYY-MM-DD',
}
